import React from 'react';
import { formatDeliveryDate, formatLockDate, getCutoffTime } from 'utils/deliveryDates';
import { FONTS } from 'styles/theme';
import { useMediaQuery } from 'hooks/useMediaQuery';

const INK = '#2B2118';
const INK_MUTED = '#5C4D40';
const PRIMARY = '#A24A12';

const NoMealsNoticeModal = ({ dates, onClose }) => {
    const isWide = useMediaQuery('(min-width: 720px)');
    const single = dates.length === 1;
    const deadline = (date) => formatLockDate(getCutoffTime(date));

    return (
        <div
            onClick={(e) => { if (e.target === e.currentTarget) onClose(); }}
            style={{
                position: 'fixed', inset: 0, backgroundColor: 'rgba(43, 33, 24, 0.55)', zIndex: 1000,
                display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '16px',
            }}
        >
            <div
                role="dialog"
                aria-modal="true"
                aria-labelledby="no-meals-notice-title"
                style={{
                    backgroundColor: '#fff', width: '100%', maxWidth: '420px', borderRadius: '16px',
                    padding: isWide ? '24px 26px 20px' : '20px 18px 16px', boxSizing: 'border-box',
                    boxShadow: '0 12px 40px rgba(0, 0, 0, 0.18)', fontFamily: FONTS.sans, color: INK,
                }}
            >
                <h3 id="no-meals-notice-title" style={{ margin: 0, fontSize: isWide ? '22px' : '20px', lineHeight: 1.25, fontWeight: 900 }}>
                    {single ? `No meals yet for ${formatDeliveryDate(dates[0])}` : 'Some deliveries have no meals yet'}
                </h3>
                {single ? (
                    <p style={{ margin: '10px 0 0', fontSize: '15px', lineHeight: 1.5, color: INK_MUTED }}>
                        Please select meals for {formatDeliveryDate(dates[0])} by {deadline(dates[0])}. Otherwise, we'll skip this delivery.
                    </p>
                ) : (
                    <>
                        <p style={{ margin: '10px 0 0', fontSize: '15px', lineHeight: 1.5, color: INK_MUTED }}>
                            Please select meals for these dates by their deadlines. Otherwise, we'll skip those deliveries.
                        </p>
                        <ul style={{ margin: '8px 0 0', paddingLeft: '20px', fontSize: '15px', lineHeight: 1.6, color: INK }}>
                            {dates.map(date => (
                                <li key={date}>{formatDeliveryDate(date)} <span style={{ color: INK_MUTED }}>(by {deadline(date)})</span></li>
                            ))}
                        </ul>
                    </>
                )}
                <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px', marginTop: '20px' }}>
                    <button
                        type="button"
                        onClick={onClose}
                        style={{
                            minHeight: '44px', padding: '0 24px', borderRadius: '8px', border: 0,
                            background: PRIMARY, color: '#fff', fontFamily: 'inherit', fontSize: '15px', fontWeight: 700, cursor: 'pointer',
                        }}
                    >
                        Got it
                    </button>
                </div>
            </div>
        </div>
    );
};

export default NoMealsNoticeModal;
